import React from 'react'
import { Helmet } from 'react-helmet-async'
import { BreadcrumbsJsonLd } from '@/components/seo/Breadcrumbs'

export default function PrivacyPolicyPage() {
  return (
    <main className="min-h-screen bg-background">
      <Helmet>
        <title>Privacy Policy | Raintree Chinese Medicine</title>
        <meta name="description" content="Read how Raintree Chinese Medicine handles your personal and health information under the Privacy Act 1988 (Cth) and the APPs." />
        <meta property="og:title" content="Privacy Policy | Raintree Chinese Medicine" />
        <meta property="og:description" content="Read how Raintree Chinese Medicine handles your personal and health information under the Privacy Act 1988 (Cth) and the APPs." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://raintreechinesemedicine.com.au/privacy" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Privacy Policy | Raintree Chinese Medicine" />
        <meta name="twitter:description" content="Read how Raintree Chinese Medicine handles your personal and health information under the Privacy Act 1988 (Cth) and the APPs." />
      </Helmet>
      <BreadcrumbsJsonLd />
      <section className="container mx-auto px-4 py-16 max-w-3xl">
        <p className="mb-4">
          <a
            href="https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/public/Public/Raintree-Privacy-Policy-2025-08-17.pdf"
            download="Raintree-Privacy-Policy-2025-08-17.pdf"
            className="inline-block text-white bg-black hover:bg-gray-800 rounded px-4 py-2 no-underline"
          >
            download full privacy policy
          </a>
        </p>
        <h1 className="text-3xl font-semibold mb-6">Privacy at Raintree</h1>
        <p className="mb-6">
          We respect your privacy and follow the Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs). Because we provide healthcare, we handle your health information with extra care.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">What we collect</h2>
        <p className="mb-6">
          Your contact details, appointment information, and clinical notes (history, treatments, plans, referrals). We may also collect technical website data (e.g. pages viewed) via cookies/analytics.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">How we use your information</h2>
        <p className="mb-6">
          To provide and coordinate your care, manage bookings and reminders, run the clinic safely, and communicate with you. We only send marketing (like newsletters) if you’ve opted in—you can unsubscribe anytime. We advertise in line with AHPRA’s guidelines and the National Law.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Where it’s stored</h2>
        <p className="mb-6">
          Clinical records are kept on secure servers in Australia (Sydney region). Some website analytics providers may process technical data overseas—see our cookie settings for your choices.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Payments</h2>
        <p className="mb-6">
          We process in-person payments via a card terminal. We don’t store card numbers.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Email &amp; messages</h2>
        <p className="mb-6">
          Email isn’t always secure—please avoid detailed health info by email. For sensitive matters, use phone or our booking/contact forms.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">How long we keep records</h2>
        <p className="mb-6">
          At least 7 years after the last entry for adults, and until age 25 for children (or longer if the law requires).
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Your rights</h2>
        <p className="mb-6">
          You can request access to, or correction of, your information. We’ll respond within a reasonable time.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Data breaches</h2>
        <p className="mb-6">
          If a breach is likely to cause serious harm, we’ll notify you and the OAIC under the Notifiable Data Breaches scheme, and tell you what you can do.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Questions or complaints</h2>
        <p className="mb-2">
          Raintree Chinese Medicine &amp; Acupuncture Clinic
          <br />
          31 Burgess Drive, Tewantin QLD 4565
          <br />
          +61 7 5240 9192 · renee@raintreechinesemedicine.com.au
          <br />
          If we can’t resolve your concern, you can contact the OAIC: 1300 363 992; GPO Box 5218, Sydney NSW 2001; oaic.gov.au.
        </p>
      </section>
    </main>
  )
}


